import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { UiMarkdownViewerModule } from '@fitscovery/partner-web/ui/markdown-viewer';
import { UiThemeModule } from '@fitscovery/partner-web/ui/theme';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FeaturePartnerHomepageComponent } from './feature-partner-homepage/feature-partner-homepage.component';
import { HomepageSectionsPipe } from './shared/pipes';
import { UiCustomButtonComponent } from './shared/ui/ui-custom-button/ui-custom-button.component';
import { UiSocialMediaLinkComponent } from './shared/ui/ui-social-media-link/ui-social-media-link.component';
import { FeatureDefaultTemplateComponent } from './templates/default/feature-default-template/feature-default-template.component';
import { UiDefaultBannerComponent } from './templates/default/ui/ui-default-banner/ui-default-banner.component';
import { UiDefaultSectionEvenComponent } from './templates/default/ui/ui-default-section-even/ui-default-section-even.component';
import { UiDefaultSectionLastComponent } from './templates/default/ui/ui-default-section-last/ui-default-section-last.component';
import { UiDefaultSectionOddComponent } from './templates/default/ui/ui-default-section-odd/ui-default-section-odd.component';
import { FeatureGrooveTemplateComponent } from './templates/groove/feature-groove-template/feature-groove-template.component';
import { UiGrooveBannerComponent } from './templates/groove/ui/ui-groove-banner/ui-groove-banner.component';
import { UiGrooveSectionEvenComponent } from './templates/groove/ui/ui-groove-section-even/ui-groove-section-even.component';
import { UiGrooveSectionLastComponent } from './templates/groove/ui/ui-groove-section-last/ui-groove-section-last.component';
import { UiGrooveSectionOddComponent } from './templates/groove/ui/ui-groove-section-odd/ui-groove-section-odd.component';
import { ImageDescriptionPipe } from './shared/pipes/image-description.pipe';
import { UiDefaultSkeletonLoaderComponent } from './templates/default/ui/ui-default-skeleton-loader/ui-default-skeleton-loader.component';

const DEFAULT_TEMPLATE_COMPONENTS = [
  FeatureDefaultTemplateComponent,
  UiDefaultBannerComponent,
  UiDefaultSectionOddComponent,
  UiDefaultSectionEvenComponent,
  UiDefaultSectionLastComponent,
  UiDefaultSkeletonLoaderComponent
];

const GROOVE_TEMPLATE_COMPONENTS = [
  FeatureGrooveTemplateComponent,
  UiGrooveBannerComponent,
  UiGrooveSectionEvenComponent,
  UiGrooveSectionOddComponent,
  UiGrooveSectionLastComponent
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LazyLoadImageModule,
    UiThemeModule,
    NgxSkeletonLoaderModule,
    UiMarkdownViewerModule,
  ],
  declarations: [
    DEFAULT_TEMPLATE_COMPONENTS,
    GROOVE_TEMPLATE_COMPONENTS,
    UiCustomButtonComponent,
    FeaturePartnerHomepageComponent,
    UiSocialMediaLinkComponent,
    HomepageSectionsPipe,
    ImageDescriptionPipe
  ],
})
export class PartnerHomepageModule { }
